<template>
  <div>
    <CottiCancellation v-if="brand === 'COTTI'"/>
    <TeacatCancellation v-else/>
  </div>
</template>

<script>
import CottiCancellation from './components/cotti-cancellation'
import TeacatCancellation from './components/teacat-cancellation'

export default {
  name: 'Cancellation',
  components: {
    CottiCancellation,
    TeacatCancellation
  },
  data() {
    return {
      brand: ''
    }
  },
  mounted () {
    this.brand = this.$config.env.VUE_APP_BRAND
  }
  
}
</script>

<style scoped lang="scss">
</style>
